























































































































/* Created- 11 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaBaseView from "../../Base/ParticaBaseView.vue";
import { PageContent, EnumDTO } from "../../../Models/Components.model";
import ContentSelector from "@/Ui-Components/Content/ContentSelector.vue";
import PageTurner from "@/Ui-Components/Issue/PageTurner.vue";
import { IssueModel, Pdfinfo, IssueLinkModel, Pdfpage, WordsmartCustomRegexDTORegexType } from "../../../Generated/ParticaAPI";
import { IssueService, IIssueService } from "../../../BusinessServices/issue";
import { eParticaAction, getActionName, ParticaEvent } from "../../../Models/ParticaEvent";
import { IWordsmartService } from "../../../BusinessServices/wordsmart";
import { IPdfContentService } from "../../../BusinessServices/issuecontent";
import { ArrayUtils } from "../../../BusinessServices/arrayutils";
import { ButtonConfig, ButtonType } from "../../../Models/Buttons";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaIssueBase from "../../Base/ParticaIssueBase.vue";
import { ParticaItem } from "../../../Models/ParticaItem";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";

@Component(
	{
		name: "IssueTOC",
		components: {
			ParticaError,
			ParticaRowContainer,
			PageTurner,
			ContentSelector,
			ButtonList,
			ParticaCard,
			ParticaView,
			ParticaColumnContainer,
			ParticaRightDrawer
		}
	})
export default class IssueTOC extends ParticaIssueBase {
	@Prop() private id: number;
	private issue: IssueModel | null = null;
	private pageNumber: number = 1;
	private pageInfo: Pdfinfo = new Pdfinfo();
	private content: PageContent = new PageContent();
	private pageContent: PageContent = new PageContent();
	private issueService: IIssueService;
	private wordsmartService: IWordsmartService;
	private pdfContentService: IPdfContentService;
	private links: IssueLinkModel[] = [];
	private selected: IssueLinkModel = new IssueLinkModel();
	private expression: string = "\\d+";
	private width: number = 799;
	private wstype: number = 0;
	private pagesdrawer: boolean = false;
	private isFullscreen: boolean = false;


	private linkbuttons: ButtonConfig[] = [
		{ label: "Save", action: eParticaAction.ISSUE_WORDSMART_SAVE_LINK, type: ButtonType.OK } as ButtonConfig,
		{ label: "Link OK", action: eParticaAction.ISSUE_WORDSMART_LINK_OK, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Delete", action: eParticaAction.ISSUE_WORDSMART_DELETE_LINK, type: ButtonType.Cancel } as ButtonConfig,
	];
	private wsbuttons: ButtonConfig[] = [
		{ label: "Run Wordsmart", action: eParticaAction.ISSUE_WORDSMART_PAGE, type: ButtonType.OK } as ButtonConfig,
		{ label: "Publish", action: eParticaAction.ISSUE_WORDSMART_PUBLISH, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Pages with Links", action: eParticaAction.ISSUE_WORDSMART_PAGES, type: ButtonType.Normal } as ButtonConfig,
	];

	private wstypes: any[] = [
		{ name: "Page", id: 0 } as any,
		{ name: "Email", id: 1 } as any,
		{ name: "Web (new tab)", id: 2 } as any,
		{ name: "Web (same tab)", id: 3 } as any
	];
	private regexType: WordsmartCustomRegexDTORegexType = WordsmartCustomRegexDTORegexType.Page;
	@Watch("wstype")
	private changeExpression() {
		switch (this.wstype) {
			case 0: {
				this.expression = "\\d+";
				this.regexType = WordsmartCustomRegexDTORegexType.Page;
				break;
			}
			case 1: {
				this.expression = "\\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,4}\\b";
				this.regexType = WordsmartCustomRegexDTORegexType.Email;
				break;
			}
			case 2: {
				this.regexType = WordsmartCustomRegexDTORegexType.Web;
				this.expression = "\\b((http|https|ftp|ftps)://)?([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,}(/[a-zA-Z0-9=.?&-]*)?";
				break;
			}
			case 2: {
				this.regexType = WordsmartCustomRegexDTORegexType.Web;
				this.expression = "\\b((http|https|ftp|ftps)://)?([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,}(/[a-zA-Z0-9=.?&-]*)?";
				break;
			}
		}
	}

	private getSelectedId(): string {
		if (this.selected !== undefined && this.selected.rowKey !== undefined) {
			return this.selected.rowKey;
		}
		return "";
	}

	private getLinkClass(link: IssueLinkModel): string {
		if (link.check as number < 0) {
			return "check";
		}
		if ((link.link as string).startsWith("page:")) {
			const pg: number = parseInt((link.link as string).substring(5), 10);
			if (this.issue !== null) {
				if (pg > (this.issue.numberPages as number)) {
					return "check";
				}
			}
		}
		return "ok";
	}

	private setSelected(link: IssueLinkModel) {
		this.selected = link;
	}

	private getPageLinks(): IssueLinkModel[] {
		const pglinks: IssueLinkModel[] = this.links.filter(l => l.pageNumber === this.pageNumber).sort((f1, f2) => (f1.link as string).localeCompare(f2.link as string));
		return pglinks;
	}

	private getPagesWithLinks(): number[] {
		const tmp = ArrayUtils.groupBy(this.links, l => l.pageNumber as number);
		const pages: string[] = Object.keys(tmp);
		return pages.map(Number);
	}

	@Watch("pageNumber")
	private gotoPage() {
		this.eventHandler({ action: eParticaAction.PAGE_CHANGE, item: this.pageNumber } as ParticaEvent);
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {

				case eParticaAction.ISSUE_WORDSMART_PAGE: {
					await this.wordsmartService.RunWordsmartPage(this.id, this.pageNumber, this.expression, this.regexType);
					this.selected = new IssueLinkModel();
					await this.init();
					break;
				}
				case eParticaAction.ISSUE_WORDSMART_PUBLISH: {
					await this.wordsmartService.PublishWordsmart(this.id);
					this.selected = new IssueLinkModel();
					await this.init();
					break;
				}
				case eParticaAction.ISSUE_WORDSMART_DELETE_LINK: {
					await this.wordsmartService.DeleteWordsmartLink(this.selected);
					this.removeLink(this.selected);
					this.selected = new IssueLinkModel();
					break;
				}
				case eParticaAction.ISSUE_WORDSMART_CLEAR: {
					this.selected = new IssueLinkModel();
					break;
				}
				case eParticaAction.ISSUE_WORDSMART_PAGES: {
					this.pagesdrawer = true;
					break;
				}
				case eParticaAction.ISSUE_WORDSMART_LINK_OK: {
					this.selected.check = 200;
					await this.wordsmartService.SaveWordsmartLink(this.selected);
					break;
				}
				case eParticaAction.LEFT_MOUSE_CLICK: {
					const found: any = this.links.find(l => l.rowKey === event.item.content);
					if (found !== undefined) {
						this.selected = found as IssueLinkModel;
					}
					break;
				}
				case eParticaAction.RIGHT_MOUSE_CLICK: {
					const found: any = this.links.find(l => l.rowKey === event.item.content);
					if (found !== undefined) {
						await this.wordsmartService.DeleteWordsmartLink(found as IssueLinkModel);
						this.removeLink(found as IssueLinkModel);
						this.selected = new IssueLinkModel();
					}
					break;
				}
				case eParticaAction.ISSUE_WORDSMART_SAVE_LINK: {
					await this.wordsmartService.SaveWordsmartLink(this.selected);
					break;
				}
				case eParticaAction.PAGE_CHANGE: {
					this.pageNumber = event.item as number;
					await this.loadWordsmartForPage(this.pageNumber);
					this.selected = new IssueLinkModel();
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	private removeLink(link: IssueLinkModel) {
		const found: any = this.content.items.find(i => i.content === link.rowKey);
		if (found !== undefined) {
			ArrayUtils.remove(this.content.items, found);
		}
		const found2: any = this.links.find(i => i.rowKey === link.rowKey);
		if (found2 !== undefined) {
			ArrayUtils.remove(this.links, found2);
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Wordsmart Issue";
		this.wstype = 0;
		await this.init();
		await this.getIssueNav(this.id);
	}

	private async init() {
		try {
			this.LoadingStart();
			this.issueService = this.particaServices.getIssueService();
			this.issue = await this.issueService.getIssue(this.id);
			this.pdfContentService = this.particaServices.getPdfContentService();
			this.pageInfo = await this.pdfContentService.getPageInfo(this.id);
			this.wordsmartService = this.particaServices.getWordsmartService();
			this.links = await this.wordsmartService.GetWordsmartForIssue(this.id);
			await this.loadWordsmartForPage(this.pageNumber);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}

	private async loadWordsmartForPage(pageNumber: number) {
		try {
			this.LoadingStart();
			if (this.pageInfo !== undefined && this.pageInfo.pages !== undefined) {
				const page: Pdfpage = this.pageInfo.pages[this.pageNumber - 1];
				if (page !== undefined) {
					this.content = this.wordsmartService.GetPageContent(
						this.links,
						pageNumber,
						page.width as number,
						page.height as number
					);
					if (this.issue != null) {
						this.content.src = `${this.stateconfig.thumburl}${this.issue.guid}/thumb/${this.pageNumber}.1200.jpg`;
					}
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
	private toggleFullscreen(event: any) {
		const elem = document.documentElement;
		// @ts-ignore
		if (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled) {
			if (!this.isFullscreen) {
				if (elem.requestFullscreen) {
					elem.requestFullscreen();
					this.isFullscreen = true;
					return;
					// @ts-ignore
				} else if (elem.webkitRequestFullscreen) {
					// @ts-ignore
					elem.webkitRequestFullscreen();
					this.isFullscreen = true;
					return;
					// @ts-ignore
				} else if (elem.mozRequestFullScreen) {
					// @ts-ignore
					elem.mozRequestFullScreen();
					this.isFullscreen = true;
					return;
					// @ts-ignore
				} else if (elem.msRequestFullscreen) {
					// @ts-ignore
					elem.msRequestFullscreen();
					this.isFullscreen = true;
					return;
				}
			} else {
				if (document.exitFullscreen) {
					document.exitFullscreen();
					this.isFullscreen = false;
					return;
					// @ts-ignore
				} else if (document.webkitExitFullscreen) {
					// @ts-ignore
					document.webkitExitFullscreen();
					this.isFullscreen = false;
					return;
					// @ts-ignore
				} else if (document.mozCancelFullScreen) {
					// @ts-ignore
					document.mozCancelFullScreen();
					this.isFullscreen = false;
					return;
					// @ts-ignore
				} else if (document.msExitFullscreen) {
					// @ts-ignore
					document.msExitFullscreen();
					this.isFullscreen = false;
					return;
				}
			}
		}
	}

}
